<template>
  <div class="note-container-process">
    <div class="left">
      <h2>dodał:{{ note.admin }}</h2>
      <h2>
        {{
          note.creation_date.substring(0, 10) +
            ", " +
            note.creation_date.substring(11, 19)
        }}
      </h2>
      <h2>
        Kat: <span class="capitalize">{{ note.category }}</span>
      </h2>
    </div>
    <div class="right">
      <div class="message" v-for="message in note.messages" :key="message.id">
        <p>
          {{
            message.creation_date.substring(0, 10) +
              ", " +
              message.creation_date.substring(11, 19)
          }}
        </p>
        <h1>{{ message.message }}</h1>
      </div>
      <h1 @click="addNewMessageToNote(note.id)" class="add-message">
        + Dodaj wiadomość
      </h1>
    </div>
  </div>
</template>
<script>
export default {
  name: "CustomNote",
  props: ["note"],
  emits: ["newMessage"],
  methods: {
    addNewMessageToNote(id) {
        this.$emit('newMessage',id)
    },
  },
};
</script>
<style scoped>
.note-container-process {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  padding: 0px 8px;
  width: 100%;
  height: 160px;
  margin: 10px 0;
  border: 0.5px solid #090741;
  border-radius: 5px;
}
.left {
  width: 20%;
}
.right {
  width: 80%;
  max-height: 100%;
  overflow-y: auto;
 
}
@media screen and (max-width:1500px) {
  .left{
    width: 30%;
  }
  .right{
    width: 70%;
  }
}
.left h2 {
  font-weight: 400;
  font-size: 14px;
  line-height: 0px;
  display: flex;
  align-items: center;
  line-height: 4px;
  color: rgba(9, 7, 65, 0.75);
}
.capitalize {
  text-transform: capitalize;
}
.message {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 5px 15px;
  gap: 5px;
  min-width: 465px;
  background: rgba(9, 7, 65, 0.05);
  border-radius: 5px;
  margin: 10px 0;
}
.add-message {
  cursor: pointer;
  color: #e2037e;
  font-weight: 400;
  font-size: 18px;
}
</style>
